<section class="rounded-lg bg-primary-50 p-4">
  <form [formGroup]="formGroup" class="flex flex-1 flex-col gap-4">
    <div>
      <h4 class="text-primary-900">
        {{ "prestation.durationForm.title" | transloco }}
      </h4>
      <p class="text-paragraph-xs-reg">
        {{ "prestation.durationForm.subtitle" | transloco }}
      </p>
    </div>

    <div class="flex flex-1 flex-row gap-4">
      <div class="flex flex-1 flex-col items-start">
        <label for="hours" class="text-paragraph-xs-med text-greyscale-700">
          {{ "calculator.label.hours" | transloco }}
        </label>
        <p-inputNumber
          id="hours"
          formControlName="hours"
          [fluid]="true"
          suffix="h"
        />
        <app-error [control]="formGroup.get('hours')!" />
      </div>
      <div class="flex flex-1 flex-col items-start">
        <label for="minutes" class="text-paragraph-xs-med text-greyscale-700">
          {{ "calculator.label.minutes" | transloco }}
        </label>
        <p-inputNumber
          id="minutes"
          formControlName="minutes"
          [fluid]="true"
          suffix="m"
        />
        <app-error [control]="formGroup.get('minutes')!" />
      </div>
    </div>
    <app-error [control]="formGroup" />
  </form>
</section>
